import { render, staticRenderFns } from "./ConfigAlertEmail.vue?vue&type=template&id=74639c3a&"
import script from "./ConfigAlertEmail.vue?vue&type=script&lang=js&"
export * from "./ConfigAlertEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports